import { Injectable } from '@angular/core';

import { ApiService } from '@dav-core/services/api.service';
import { HistoryService } from '@dav-core/services/history.service';
import { ContractHistoryResponse } from '@dav-model/api/response/pending-contract.response.model';
import { UserResponse } from '@dav-model/login/response/user.response.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as HistoryActions from './history.actions';
import * as historyReducer from './history.reducer';
import * as fromRoot from '../reducers';

@Injectable()
export class HistoryEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store: Store<fromRoot.State>) {
  }

  getContracts$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(HistoryActions.GET_CONTRACTS),
    withLatestFrom(
      this.store.select(state => state.userState.user)
    ),
    mergeMap(([action, user]: [HistoryActions.GetContractsAction, UserResponse]) => {
        const allDealers = JSON.parse(JSON.stringify(user.allDealers));

        if (allDealers && allDealers.length === 1) {
          allDealers[0].cmsDealerNumber = user.cmsDealerNumber;
        }

        const request = {
          cmsDealerNumber: user.cmsDealerNumber,
          lastName: action.payload.lastName,
          firstName: action.payload.firstName,
          vin: action.payload.vin,
          programId: user.programId,
          allDealers: allDealers
        };

        return this.apiService.getContractHistory(request).pipe(
          // If successful, dispatch success action with result
          map((response: ContractHistoryResponse) => {
            const historyFilters = HistoryService.fetchContractFilters(response.contracts);

            return {
              type: HistoryActions.GET_CONTRACTS_SUCCESS,
              payload: { contracts: response, filters: historyFilters }
            };
          }),
          // If request fails, dispatch failed action
          catchError((error) => {
            console.warn(error);

            return of({
              type: HistoryActions.HISTORY_FAILURE,
              payload: error
            });
          })
        );
      }
    )
  ));


  undoDeclineContract$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(HistoryActions.UNDO_DECLINE_CONTRACT),
    withLatestFrom(
      this.store.select(state => state.historyState),
      this.store.select(state => state.userState.user)
    ),
    mergeMap(([action, historyState, user]:
                [HistoryActions.UndoDeclineContractAction, historyReducer.State, UserResponse]) => {

        const allDealers = JSON.parse(JSON.stringify(user.allDealers));

        if (allDealers && allDealers.length === 1) {
          allDealers[0].cmsDealerNumber = user.cmsDealerNumber;
        }

        const request = {
          cmsDealerNumber: user.cmsDealerNumber,
          programId: user.programId,
          allDealers: allDealers,
          contract: action.payload
        };

        return this.apiService.undoDecline(request).pipe(
          // If successful, dispatch success action with result
          map(() => {

            let contracts = historyState.contracts;

            if (request.contract.status) {

              contracts = historyState.contracts.map((contract) => {
                if (contract.econContractNumber === request.contract.econContractNumber) {
                  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

                  const year = new Date().getFullYear();
                  const month = months[new Date().getMonth()];
                  const day = new Date().getDate();

                  contract.modifiedDate = `${month} ${day}, ${year}`;
                  contract.status = 'Pending';
                  contract.statusCode = 'P';

                  return contract;
                }

                return contract;
              });

            }

            const historyFilters = HistoryService.fetchContractFilters(contracts);

            return {
              type: HistoryActions.UNDO_DECLINE_CONTRACT_SUCCESS,
              payload: { contracts: contracts, filters: historyFilters }
            };
          }),
          // If request fails, dispatch failed action
          catchError((error) => {
            return of({
              type: HistoryActions.HISTORY_FAILURE,
              payload: error
            });
          })
        );
      }
    )
  ));
}
